<dxo-card [bodyHeader]="headerText" class="form-card">
  <ng-content></ng-content>

  <benefits-button-group *ngIf="!onlyShowNext; else nextOnly" class="normal-stepper">
    <dxo-button (handleClick)="backClick.emit()" [disabled]="disableBack">
      <dxo-icon [left]="true">arrow_back_ios</dxo-icon>

      {{ backButtonText }}
    </dxo-button>

    <dxo-button [primary]="true" (handleClick)="nextClick.emit()" [disabled]="disableNext">
      {{ nextButtonText }}

      <dxo-circular-loader *ngIf="loading; else submit" color="white" size="tiny"></dxo-circular-loader>

      <ng-template #submit>
        <dxo-icon [right]="true">arrow_forward_ios</dxo-icon>
      </ng-template>
    </dxo-button>
  </benefits-button-group>
  <ng-template #nextOnly>
    <dxo-button class="lone-button" [primary]="true" (handleClick)="nextClick.emit()" [disabled]="disableNext">
      {{ nextButtonText }}

      <dxo-circular-loader *ngIf="loading; else submit" color="white" size="tiny"></dxo-circular-loader>

      <ng-template #submit>
        <dxo-icon [right]="true">arrow_forward_ios</dxo-icon>
      </ng-template>
    </dxo-button>
  </ng-template>
</dxo-card>
